// @flow
import ImageTitleBodyButtonModal from './ImageTitleBodyButtonModalContainer'
export default ImageTitleBodyButtonModal
